<template>
  <div>
    <el-form label-position="right" label-width="100px" :model="formPassword" :rules="rules" ref="formPassword">
      <el-form-item label="用户名称">
        <p>{{ userName }}</p>
      </el-form-item>
      <el-form-item label="旧密码" prop="old">
        <el-input v-model="formPassword.old" style="width: 50%" placeholder="请输入旧密码">
        </el-input>
        <el-link type="primary" style="margin-left: 10px" @click="forgotPassword">忘记密码?</el-link>
      </el-form-item>
      <el-form-item label="新密码" prop="pass">
        <el-input type="password" v-model="formPassword.pass" autocomplete="off" style="width: 50%"
          placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="密码确认" prop="checkPass">
        <el-input type="password" v-model="formPassword.checkPass" autocomplete="off" style="width: 50%"
          placeholder="请再次输入新密码"></el-input>
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button @click="backAccount">返 回</el-button>
      <el-button type="primary" :loading="loadingBtn" @click="submitPassword('formPassword')">确认修改</el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formPassword.checkPass !== "") {
          this.$refs.formPassword.validateField("checkPass");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formPassword.pass) {
        callback(new Error("您两次密码输入不一致，请重新输入!"));
      } else {
        callback();
      }
    };
    return {
      loadingBtn: false,
      userName: "",
      formPassword: {
        old: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        old: [{ required: true, message: "原密码不能为空", trigger: "blur" }],
        pass: [
          { required: true, validator: validatePass, trigger: "blur" },
          {
            pattern: /\S/,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 8,
            max: 16,
            message: "请输入8-16位密码",
            trigger: "blur",
          },
          {
            pattern:
              /^(?!^\d+$)(?!^[a-z]+$)(?!^[A-Z]+$)(?!^[^a-z0-9]+$)(?!^[^A-Z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S*$/,
            message: "包含数字/字母/特殊字符至少两种",
            trigger: "blur",
          },
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    forgotPassword() {
      this.$parent.showCom = "resetPassword";
    },
    backAccount() {
      this.$parent.showCom = "Account";
    },
    submitPassword(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loadingBtn = true;
          let res = await api.loginModifyPassword({
            currentPassword: this.formPassword.old,
            newPassword: this.formPassword.checkPass,
          });
          if (res && res.status == 200) {
            this.loadingBtn = false;
            this.$message.success("修改密码成功,请重新登录！");
            setTimeout(() => {
              this.$store.dispatch("logout");
              this.$store.commit("SET_ROUTE", []);
            }, 1000);
          } else {
            this.loadingBtn = false;
          }
        }
      });
    },
  },
  created() {
    let userData = JSON.parse(window.sessionStorage.getItem("userInfo"));
    this.userName = userData.identity == 'projectAdmin' ? '系统管理员' : userData.identity ==
      'operation' ? '巨基运营' : userData.name
  },
};
</script>

<style></style>